export const error = (message: string, duration?: number) => {
  window.bridgeCallHandler('showToast', {
    toast: {
      message,
      iconType: 'failure',
      duration: duration ?? 1500,
    },
  });
};

export const success = (message: string, duration?: number) => {
  window.bridgeCallHandler('showToast', {
    toast: {
      message,
      iconType: 'success',
      duration: duration ?? 1500,
    },
  });
};
